<template>
  <div class="main print-no-padding area-detail">
    <h2 class="is-print-hide title-area">
      <span class="main-title">查看大区</span>
    </h2>
    <el-breadcrumb class="breadcrumb" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/shopManagement' }">门店设置</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/shopManagement/areaList' }">大区设置</el-breadcrumb-item>
      <el-breadcrumb-item>查看大区</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-form ref="form" label-position="left">
        <el-form-item class="item">
          <template #label>
            <form-label>大区名称</form-label>
          </template>
          <el-input style="width: 200px" v-model="form.name" placeholder="请输入" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item class="item">
          <template #label>
            <form-label>门店</form-label>
          </template>
          <div class="store-list-wrapper">
            <div class="selected-store">
              <span class="name">{{ `已选门店（${totalStoreCount}）` }}</span>
            </div>
            <div class="store-list">
              <tree ref="tree" :data="data" node-key="id" accordion></tree>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Fetch from '@/api';
import { mergeStoreData } from '@/util';
import tree from './components/tree/tree';
import formLabel from '@/components/global/form/label';

export default {
  name: 'areaDetail',
  components: {
    tree,
    formLabel
  },
  data() {
    return {
      form: {
        name: '',
        storeList: []
      },
      data: [],
      totalStoreCount: 0
    };
  },
  created() {
    this.init();
  },
  methods: {
    fetchAreaDetail() {
      const { id } = this.$route.params;
      Fetch.getArea(id).then(({ name, storeList = [] }) => {
        this.form.name = name;
        this.form.storeList = storeList;
        this.$refs.tree.setCheckedKeys(this.form.storeList);
      });
    },
    init() {
      this.getStoreList();
      this.fetchAreaDetail();
    },
    getStoreList() {
      const { id: areaId } = this.$route.params;
      return Fetch.limitedStoreForArea({ areaId, isCurrentAreaStore: 1 }).then(data => {
        this.data = mergeStoreData(data, data['86'], areaId);
        this.$nextTick(_ => {
          this.totalStoreCount = this.$refs.tree.getNodes(true).length;
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.area-detail {
  .breadcrumb {
    margin-bottom: 15px;
  }

  .item {
    display: flex;

    /deep/.el-form-item__label {
      width: 80px;
    }

    /deep/.el-form-item__content {
      display: flex;
    }

    .store-list-wrapper {
      width: 464px;
      border-radius: 4px;
      border: 1px solid #f2f2f2;

      .selected-store {
        display: flex;
        justify-content: space-between;
        padding: 0 12px;
        color: #707070;
        border-bottom: 1px solid #f2f2f2;
      }

      .store-list {
        height: 400px;
        overflow: auto;
      }
    }
  }
}
</style>
